import React, { useState } from 'react';
import { SendMessage } from './App.js'

export default function DanmuImageCard({ imageId, song, onClick, innerRef }) {

  const [isTouching, setIsTouching] = useState(false);
  const [canSend, setCanSend] = useState(true);

  const handleTouchStart = () => {
    //console.log('Image touched down');
    // Set isTouching to true to indicate touch is started
    setIsTouching(true);
    // Additional logic if needed
  };

  const handleTouchEnd = () => {
    //console.log('Image released');
    // Set isTouching to false to indicate touch is ended
    setIsTouching(false);
    // Additional logic if needed
  };

  const handleImageClick = () => {
    if (imageId !== "blank" && canSend) {
      SendMessage(`[{"type":"DANMU_IMAGE","imageId":${imageId}}]`);
      console.log(`danmu ${imageId}`);
      setCanSend(false); // Disable sending temporarily
      setTimeout(() => {
        setCanSend(true); // Re-enable sending after a cooldown period
      }, 1000); // Adjust the cooldown period (in milliseconds) as needed
    }
  };

  return (
    <div  style={{ padding: "10px",}}
          onClick={handleImageClick}
          onTouchEnd={handleTouchEnd}
          onTouchStart={handleTouchStart}>
      <img className="touchable-image"
              style={{
                width: '100%',
                height: 'auto',
                transform: isTouching ? 'scale(0.6)' : 'scale(1)', // Scale the image down when touching
                transition: 'transform 0.2s ease', // Add transition effect for smooth scaling
              }}
      src={`https://starboxkod.com/danmu/${imageId}m.gif`}/>
    </div>
  )
}
